type Props = {
  value1?: string;
  value2?: string;
  vertical?: boolean;
};

function JSelectDisplayOption({
  value1 = "",
  value2 = "",
  vertical = true,
}: Props) {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: vertical ? "column" : "row",
      }}
    >
      {value1}
      <div
        style={{
          color: "grey",
          fontSize: vertical ? "0.8em" : "1em",
          marginLeft: vertical ? 0 : 5,
        }}
      >
        {value2}
      </div>
    </div>
  );
}

export default JSelectDisplayOption;
